import type { FunctionComponent } from 'react';

import { useMemberId } from '@trello/authentication';
import { useBoardMembers } from '@trello/business-logic-react/board';
import { hasValidInvitationLinkForModel } from '@trello/invitation-links';
import type { RouteId } from '@trello/router';
import { useRouteParams } from '@trello/router';

import { useConfirmEmailModalMemberFragment } from './ConfirmEmailModalMemberFragment.generated';
import { LazyConfirmEmailModal } from './LazyConfirmEmailModal';

export const PossiblyRenderConfirmEmailModal: FunctionComponent<{
  boardId: string;
}> = ({ boardId }) => {
  const { getMemberPermissionLevel } = useBoardMembers(boardId);
  const memberId = useMemberId();
  const { shortLink } = useRouteParams<
    RouteId.BOARD | RouteId.BOARD_REFERRAL
  >();
  const { data: member } = useConfirmEmailModalMemberFragment({
    from: { id: memberId },
  });

  const hasValidInviteLink = hasValidInvitationLinkForModel(
    'board',
    {
      id: boardId,
      shortLink,
    },
    getMemberPermissionLevel(memberId),
  );

  if (!member?.confirmed && hasValidInviteLink) {
    return <LazyConfirmEmailModal boardId={boardId} />;
  }

  return null;
};
